import {t, store} from '@eitje/bridge'
import {Association, dbConfig} from './active_record'

const noop = i => i
const baseURL = 'http://localhost:3000'

const defaultConfig = {
	t,
	baseURL,
	store,
	alert: noop,
	getRefreshToken: noop,
	logout: noop,
	stampFields: {
		posts: 'created_at',
	},
	success: noop,
	dbConfig,
	createUrls: {},
	updateUrls: {},
}

const createAssociation = arr => {
	return new Association(arr)
}

let config = {...defaultConfig, createAssociation}

const setup = obj => {
	config = {...config, ...obj}
}

export {setup, config}
